import {LOGIN_USER_REQUEST, REGISTER_USER_REQUEST, LOGOUT, ACCEPT_INVITE_REQUEST} from "./reducer";

export const loginUser = (email : string, password : string) => ({
    type: LOGIN_USER_REQUEST,
    payload: {
        email,
        password
    }
});


export const registerCustomer = (name : string, email : string, password : string, company : string) => ({
    type: REGISTER_USER_REQUEST,
    payload: {
        name,
        email,
        password,
        company
    }
});

export const logout = () => ({
    type: LOGOUT
});

export const acceptInvite = (email : string, password : string, inviteCode : string) => ({
    type: ACCEPT_INVITE_REQUEST,
    payload: {
        email,
        password,
        inviteCode
    }
});